import React, { Component } from "react";
import axios from "axios";
import { Container, Row, Col } from "reactstrap";
import PriceInput from "./PriceInput";
import ComputedValue from "./ComputedValue";
import utilities from "./Utilities";

let Utilities = new utilities();

class PriceCalculator {
  constructor(props) {
    this.userFields = {
      artworkHeight: null,
      artworkWidth: null,
      glazing: null,
      matteWidth: null,
      frameType: null,
      backing: null,
      matteCost: null,
      matteColor: null,
      quantity: 1,
      hanging: null,
    };

    this.calculatedValues = {
      artworkHeightNominal: 0,
      artworkWidthNominal: 0,
      windowHeightNominal: 0,
      windowWidthNominal: 0,
      frameHeightNominal: 0,
      frameWidthNominal: 0,
      externalHeightNominal: 0,
      externalWidthNominal: 0,

      frameWidth: 0,
      frameMaterialRequired: 0,
      piecesOfFrameMaterialRequired: 0,
      glazingBackingArea: 0,

      frameMaterialSellingCost: 0,
      glazingMaterialSellingCost: 0,
      matteCost: 0,
      backingCost: 0,
      hangingCost: 0,
      hangingType: 0,
      laborCost: 0,
      otherCost: 0,
      totalCost: 0,

      matteSuggestion: 0,
      maxFrameNominalDimensionSmallerDim: 0,
      maxFrameNominalDimensionLargerDim: 0,
      maxArtworkNominalDimensionLargerDim: 0,
      maxArtworkNominalDimensionSmallerDim: 0,
      tax: 0,

      hangingDropdownRefs: {},
    };

    this.definitions = [];

    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));

    let updatedTimestamp = JSON.parse(
      localStorage.getItem("priceDefinitionsTimestmap")
    );

    if (
      Utilities.isENU(priceDefinitions) ||
      Utilities.isENU(updatedTimestamp) ||
      Date.now() > parseInt(updatedTimestamp) + 900000
    ) {
      axios
        .get("/api/admin-settings")
        .then(
          function (res) {
            res.data.data
              .filter((item) => item.type === "frame")
              .map((item) => {
                item.description =
                  "<strong>" +
                  item.name +
                  "</strong> (" +
                  item.frameWidth +
                  " cm Wide)";
                return item;
              });

            this.definitions = res.data.data;
            let dateNow = JSON.stringify(Date.now());

            localStorage.setItem(
              "priceDefinitions",
              JSON.stringify(res.data.data)
            );
            localStorage.setItem(
              "priceDefinitionsTimestmap",
              JSON.stringify(dateNow)
            );
          }.bind(this)
        )
        .catch(function (e) {}.bind(this));
    } else {
      this.definitions = priceDefinitions;
    }
  }

  getMatteIdByColor(oversized) {
    return this.definitions
      .filter((item) => item.type === "matte-color")
      .filter((item) => item.oversizedMattColor === oversized)
      .filter((item) => {
        return (
          this.userFields.matteColor === item.value ||
          this.userFields.matteColor === item.name
        );
      })[0].adminId;
  }

  getArtworkWidthExternal() {
    return this.calculatedValues.externalWidthNominal;
  }

  getArtworkHeightExternal() {
    return this.calculatedValues.externalHeightNominal;
  }

  setHanging(value) {
    this.userFields.hanging = value;
  }

  setArtworkWidth(value) {
    this.userFields.artworkWidth = value;
    this.userFields.matBorderCounter = 5;
  }
  setArtworkHeight(value) {
    this.userFields.artworkHeight = value;
  }
  setGlazing(value) {
    this.userFields.glazing = value;
  }
  setMatteWidth(value) {
    this.userFields.matteWidth = value;
  }
  setFrameStyle(value, id) {
    this.userFields.frameType = value;
    this.userFields.frameId = id || 1;
  }
  setBacking(value) {
    this.userFields.backing = value;
  }
  setMatteColor(value) {
    this.userFields.matteColor = value;
  }
  setGlazing(value) {
    this.userFields.glazing = value;
  }
  setQuantity(value) {
    this.userFields.quantity = value;
  }

  getFrameId() {
    return this.userFields.frameId;
  }

  getTax() {
    let taxValues = this.definitions.filter(function (item) {
      if (item.type === "tax") {
        return true;
      }

      return false;
    });

    if (taxValues[0] === undefined) {
      return undefined;
    }

    if (taxValues[0].value === 0) {
      return false;
    } else {
      window.globalVars.tax = taxValues[0].value;
      return taxValues[0].value;
    }
  }

  getMatteSuggestion() {
    return this.calculatedValues.matteSuggestion;
  }

  isValidArtworkDimension(width, height, currentPage) {
    currentPage = currentPage || "";

    let maxFrameNominalDimensions = this.definitions
      .filter(function (item) {
        if (item.type === "matte-cost") {
          return true;
        }

        return false;
      })
      .sort(function (a, b) {
        return b.largestDim - a.largestDim;
      });

    // let maxFrameNominalDimensionLargerDim = maxFrameNominalDimensions[0].largestDim;
    // let maxFrameNominalDimensionSmallerDim = maxFrameNominalDimensions[0].smallestDim;
    //
    // let maxArtworkNominalDimensionLargerDim = maxFrameNominalDimensionLargerDim //- 2 * (this.userFields.matteWidth || 0);
    // let maxArtworkNominalDimensionSmallerDim = maxFrameNominalDimensionSmallerDim //- 2 * (this.userFields.matteWidth || 0);

    let maxArtworkNominalDimensionLargerDim = 150;
    let maxArtworkNominalDimensionSmallerDim = 100;

    let bigger = width > height ? width : height;
    let smaller = width > height ? height : width;
    let minSize = 10;

    if (bigger < minSize || smaller < minSize) {
      return "Sorry, but the minimum artwork size we frame is 10cm x 10cm.";
    }

    if (bigger > maxArtworkNominalDimensionLargerDim) {
      if (currentPage.indexOf("size") === -1) {
        return "We’re sorry, the external frame size is now bigger than 150cm x 100cm. You could reduce the mat width or <a href='/contact-us' target='_blank'>contact us</a> with your requirements.";
      } else {
        return "We’re sorry, but artwork bigger than 150cm x 100cm requires a little more information. Please <a href='/contact-us' target='_blank'>contact us</a> for a custom quote.";
      }
      // return "The longer side of the frame has to be less than " + (maxArtworkNominalDimensionLargerDim + 1) + "cm";
    }

    if (smaller > maxArtworkNominalDimensionSmallerDim) {
      if (currentPage.indexOf("size") === -1) {
        return "We’re sorry, the external frame size is now bigger than 150cm x 100cm. You could reduce the mat width or <a href='/contact-us' target='_blank'>contact us</a> with your requirements.";
      } else {
        return "We’re sorry, but artwork bigger than 150cm x 100cm requires a little more information. Please <a href='/contact-us' target='_blank'>contact us</a> for a custom quote.";
      }
      // return "The shorther side of the frame has to be less than " + (maxArtworkNominalDimensionSmallerDim + 1) + "cm";
    }

    return true;
  }

  getFrameStyleColor() {
    if (Utilities.isENU(this.userFields.frameType)) {
      return null;
    }

    return this.definitions
      .filter((item) => item.type === "frame")
      .filter(
        (item) =>
          this.userFields.frameId === item.adminId ||
          this.userFields.frameType === item.description
      )
      .map((item) => item.rgb)[0];
  }

  getFrameImgUrl(framestyle) {

    if (framestyle)
      return this.definitions
        .filter((item) => item.type === "frame")
        .filter((item) => framestyle === item.description)
        .map((item) => item.imageUrl)[0];

    if (Utilities.isENU(this.userFields.frameType)) {
      return null;
    }

    return this.definitions
      .filter((item) => item.type === "frame")
      .filter((item) => this.userFields.frameType === item.description)
      .map((item) => item.imageUrl)[0];
  }

  getMatteColorRGB() {
    if (Utilities.isENU(this.userFields.matteColor)) {
      return null;
    }

    return this.definitions
      .filter((item) => item.type === "matte-color")
      .filter((item) => {
        return (
          this.userFields.matteColor === item.value ||
          this.userFields.matteColor === item.name
        );
      })
      .map((item) => item.rgb)[0];
  }

  getFrameStyles(frameSize, initial) {
    if (initial) {
      return this.definitions
        .filter((item) => item.type === "frame")
        .map((item) => {
          if (parseFloat(item.frameWidth) >= frameSize) {
            return {
              name: item.color,
              color: item.color.toLowerCase(),
              width: item.frameWidth,
              description: item.description,
              value: item.description,
              rgb: item.rgb,
              url: item.imageUrl,
              id: item.adminId,
            };
          } else return null;
        })
        .filter((item) => {
          return item !== null;
        })[0];
    }
    // }
    // console.log(frameSize);
    return this.definitions
      .filter((item) => item.type === "frame" && item.isInStock)
      .sort((a,b) => a.orderSort - b.orderSort)
      .map((item) => {
        if (parseFloat(item.frameWidth) >= frameSize) {
          return {
            name: item.color,
            color: item.color.toLowerCase(),
            width: item.frameWidth,
            description: item.description,
            value: item.description,
            rgb: item.rgb,
            url: item.imageUrl,
            id: item.adminId,
          };
        } else return null;
      })
      .filter((item) => {
        return item !== null;
      });
  }

  getBackings() {
    return this.definitions
      .filter((item) => item.type === "backing")
      .map((item) => {
        item.value = item.name;
        return item;
      });
  }

  getPopularSizes() {
    let values = this.definitions
      .filter((item) => item.type === "popular-size")
      .map((item) => {
        item.value = item.width + "x" + item.height;
        return item;
      });

    values.unshift({
      name: "Custom Size",
      value: null,
    });

    return values;
  }

  getGlazings() {
    return this.definitions
      .filter((item) => item.type === "glazing")
      .map((item) => {
        item.value = item.name;
        return item;
      });
  }

  isNotAllowedHangingComponent(value) {
    let hangingDefinition = this.definitions.filter(function (item) {
      if (item.type === "hanging-components" && item.component === value) {
        return true;
      }

      return false;
    })[0];

    let hangingMaxDimLarge = hangingDefinition.maxDimLarge;
    let hangingMaxDimSmall = hangingDefinition.maxDimSmall;

    if (
      this.calculatedValues.hangingDropdownRefs === undefined ||
      this.calculatedValues.hangingDropdownRefs.smallerExternalSize ===
        undefined
    ) {
      return false;
    }

    if (
      this.calculatedValues.hangingDropdownRefs.smallerExternalSize >
        hangingMaxDimSmall ||
      this.calculatedValues.hangingDropdownRefs.biggerExternalSize >
        hangingMaxDimLarge
    ) {
      return true;
    }

    return false;
  }

  getHangings() {
    return this.definitions
      .filter((item) => item.type === "hanging-components")
      .map((item) => {
        item.value = item.component;
        item.displayName = item.category;
        item.name = item.component;
        return item;
      });
  }

  getMatteColors(height, width) {
    return this.definitions
      .filter((item) => item.type === "matte-color")
      .map((item) => {
        item.value = item.name;
        return item;
      })
      .filter((item) => {
        if (height <= 120 && width <= 80) {
          return item !== null && item.oversizedMattColor === false;
        } else return item !== null && item.oversizedMattColor === true;
      });
  }

  getDefinitionByTypeValue(type, value, frameMinimum) {
    let match = null;
    this.definitions.map((item) => {
      if (
        item.type === type &&
        (item.value === value ||
          item.description === value ||
          item.name === value)
      ) {
        if (type === "frame") {
          // if the framesize is above the framesizeminimum
          // pass through the item[0]
          // else item.v = item.d
          // console.log(frameMinimum, item);

          // console.log(item);
          item.value = item.description;
        }
        if (type === "hanging-components") {
          item.value = item.componentf;
        }
        match = item;
      }
    });

    return match;
  }

  dispatchError = (errorMsg) => {
    let calculatedValues = {
      artworkHeightNominal: 0,
      artworkWidthNominal: 0,
      windowHeightNominal: 0,
      windowWidthNominal: 0,
      frameHeightNominal: 0,
      frameWidthNominal: 0,
      externalHeightNominal: 0,
      externalWidthNominal: 0,
      frameWidth: 0,
      frameMaterialRequired: 0,
      piecesOfFrameMaterialRequired: 0,
      glazingBackingArea: 0,
      matteCost: 0,
      otherCost: 0,
      backingCost: 0,
      frameMaterialSellingCost: 0,
      glazingMaterialSellingCost: 0,
      hangingType: 0,
      hangingCost: 0,
      laborCost: 0,
      totalCost: 0,
      matteSuggestion: 0,
      maxFrameNominalDimensionSmallerDim: 0,
      maxFrameNominalDimensionLargerDim: 0,
      maxArtworkNominalDimensionLargerDim: 0,
      maxArtworkNominalDimensionSmallerDim: 0,
    };

    this.errorMsg = errorMsg;
  };

  roundTo3(x) {
    return Math.round(x * 1000) / 1000;
  }

  calculate = () => {
    this.errorMsg = "";

    // User fields
    let { artworkHeight, artworkWidth, frameType, glazing, matteWidth } =
      this.userFields;

    let currentPage = window.location ? window.location.href : "";

    let maxFrameNominalDimensions = this.definitions
      .filter(function (item) {
        if (item.type === "matte-cost") {
          return true;
        }

        return false;
      })
      .sort(function (a, b) {
        return b.largestDim - a.largestDim;
      });

    // if (!maxFrameNominalDimensionLargerDim) {
    //     return {
    //         status: false,
    //         retryLater: true
    //     };
    // }

    if (maxFrameNominalDimensions.length === 0) {
      return {
        success: false,
        retry: true,
      };
    }

    let maxFrameNominalDimensionLargerDim =
      maxFrameNominalDimensions[0].largestDim;
    let maxFrameNominalDimensionSmallerDim =
      maxFrameNominalDimensions[0].smallestDim;

    let maxArtworkNominalDimensionLargerDim =
      maxFrameNominalDimensionLargerDim - 2 * matteWidth;
    let maxArtworkNominalDimensionSmallerDim =
      maxFrameNominalDimensionSmallerDim - 2 * matteWidth;

    // Admin defined values
    const roundingIncrementForArtworkSize = this.definitions.filter(
      (item) => item.type === "rounding-increment-for-artwork-size"
    )[0].value;
    const matteOverlapPerEdge = this.definitions.filter(
      (item) => item.type === "matte-overlap"
    )[0].value;
    const frameAllowanePerEdge = this.definitions.filter(
      (item) => item.type === "frame-allowance-per-edge"
    )[0].value;
    const lostPerCut = this.definitions.filter(
      (item) => item.type === "frame-cut-width"
    )[0].value;

    let frameTypeDescription = this.userFields.frameType;

    let selectedFrame = this.definitions.filter(function (item) {
      if (item.type === "frame" && item.description === frameTypeDescription) {
        return true;
      }
      return false;
    })[0];

    if (!selectedFrame) {
      selectedFrame = this.definitions.filter(function (item) {
        if (item.type === "frame") {
          return true;
        }
        return false;
      })[0];
    }

    if (Utilities.isENU(selectedFrame)) {
      return {
        success: false,
        message: "Invalid Frame",
      };
    }

    let frameRabbetOverlapPerEdge = Number(selectedFrame.rabbetWidth);
    let frameWidth = Number(selectedFrame.frameWidth);
    let pieceLength = Number(selectedFrame.pieceLength);
    let framePrice = Number(selectedFrame.price);

    let artworkHeightNominal = artworkHeight;
    artworkHeightNominal = Number(artworkHeightNominal.toFixed(1));

    let artworkWidthNominal = artworkWidth;
    artworkWidthNominal = Number(artworkWidthNominal.toFixed(1));

    let windowHeightNominal = artworkHeightNominal;
    windowHeightNominal +=
      -2 *
      (!isNaN(matteWidth)
        ? matteOverlapPerEdge
        : frameRabbetOverlapPerEdge - 0.5 * frameAllowanePerEdge);
    windowHeightNominal = Number(windowHeightNominal.toFixed(1));

    let windowWidthNominal = artworkWidthNominal;
    windowWidthNominal +=
      -2 *
      (!isNaN(matteWidth)
        ? matteOverlapPerEdge
        : frameRabbetOverlapPerEdge - 0.5 * frameAllowanePerEdge);
    windowWidthNominal = Number(windowWidthNominal.toFixed(1));

    let matteBoardHeight = isNaN(matteWidth)
      ? artworkHeightNominal
      : windowHeightNominal +
        2 * (matteWidth + frameRabbetOverlapPerEdge) -
        frameAllowanePerEdge;
    let matteBoardWidth = isNaN(matteWidth)
      ? artworkWidthNominal
      : windowWidthNominal +
        2 * (matteWidth + frameRabbetOverlapPerEdge) -
        frameAllowanePerEdge;
    matteBoardHeight = Number(matteBoardHeight.toFixed(1));
    matteBoardWidth = Number(matteBoardWidth.toFixed(1));

    let internalHeight = matteBoardHeight + frameAllowanePerEdge;
    let internalWidth = matteBoardWidth + frameAllowanePerEdge;

    internalHeight = Number(internalHeight.toFixed(1));
    internalWidth = Number(internalWidth.toFixed(1));

    let rabbetEdgeHeight = internalHeight - 2 * frameRabbetOverlapPerEdge;
    let rabbetEdgeWidth = internalWidth - 2 * frameRabbetOverlapPerEdge;
    rabbetEdgeHeight = Number(rabbetEdgeHeight.toFixed(1));
    rabbetEdgeWidth = Number(rabbetEdgeWidth.toFixed(1));

    let externalHeightNominal = rabbetEdgeHeight + 2 * frameWidth;
    let externalWidthNominal = rabbetEdgeWidth + 2 * frameWidth;
    externalHeightNominal = Number(externalHeightNominal.toFixed(1));
    externalWidthNominal = Number(externalWidthNominal.toFixed(1));

    let frameHeightNominal = windowHeightNominal;
    frameHeightNominal += 2 * (!isNaN(matteWidth) ? matteWidth : 0);
    frameHeightNominal += 2 * frameRabbetOverlapPerEdge;
    frameHeightNominal = Number(frameHeightNominal.toFixed(1));

    let frameWidthNominal = windowWidthNominal;
    frameWidthNominal += 2 * (!isNaN(matteWidth) ? matteWidth : 0);
    frameWidthNominal += 2 * frameRabbetOverlapPerEdge;
    frameWidthNominal = Number(frameWidthNominal.toFixed(1));

    let frameMaterialRequired =
      2 * matteBoardHeight +
      2 * matteBoardWidth +
      4 * frameAllowanePerEdge +
      8 * (frameWidth - frameRabbetOverlapPerEdge + lostPerCut);

    let piecesOfFrameMaterialRequired = frameMaterialRequired / pieceLength;
    piecesOfFrameMaterialRequired = Math.round(piecesOfFrameMaterialRequired);

    let glazingBackingArea = (matteBoardHeight * matteBoardWidth) / 10000;
    glazingBackingArea = Number(glazingBackingArea.toFixed(3));

    let biggerFrameDimension =
      frameHeightNominal > frameWidthNominal
        ? frameHeightNominal
        : frameWidthNominal;
    let smallerFrameDimension =
      frameHeightNominal > frameWidthNominal
        ? frameWidthNominal
        : frameHeightNominal;
    let biggerArtworkDimension =
      artworkWidthNominal > artworkHeightNominal
        ? artworkWidthNominal
        : artworkHeightNominal;
    let smallerArtworkDimension =
      artworkWidthNominal > artworkHeightNominal
        ? artworkHeightNominal
        : artworkWidthNominal;

    let isValidDimensions = this.isValidArtworkDimension(
      matteBoardWidth,
      matteBoardHeight,
      currentPage
    );

    if (isValidDimensions !== true) {
      return {
        success: false,
        message: isValidDimensions,
      };
    }

    let matteCosts = this.definitions
      .filter(function (item) {
        if (item.type === "matte-cost") {
          return true;
        }

        return false;
      })
      .sort(function (a, b) {
        return b.price - a.price;
      });

    let smallerMatteCostDim, largerMatteCostDim;

    if (frameWidthNominal < frameHeightNominal) {
      smallerMatteCostDim = frameWidthNominal;
      largerMatteCostDim = frameHeightNominal;
    } else {
      smallerMatteCostDim = frameHeightNominal;
      largerMatteCostDim = frameWidthNominal;
    }

    let matteCost = matteCosts.filter(function (item) {
      if (
        item.largestDim >= largerMatteCostDim - 1 &&
        item.smallestDim >= smallerMatteCostDim - 1
      ) {
        return true;
      }

      return false;
    });

    if (matteWidth === 0) {
      // return {
      //     success: false,
      //     message: "The maximum largest dimension is " + largerMatteCostDim + ", the maximum smallest dimension is " + smallerMatteCostDim
      // }
      matteCost = 0;
    } else {
      matteCost = matteCost[matteCost.length - 1].price;
    }

    let hangingType = this.userFields.hanging;

    let hangingDefinition = this.definitions.filter(function (item) {
      if (
        item.type === "hanging-components" &&
        item.component === hangingType
      ) {
        return true;
      }

      return false;
    })[0];

    let hangingCost;
    let hangingMaxDimLarge;
    let hangingMaxDimSmall;

    if (hangingDefinition) {
      hangingCost = hangingDefinition.price;
      hangingMaxDimLarge = hangingDefinition.maxDimLarge;
      hangingMaxDimSmall = hangingDefinition.maxDimSmall;

      let smallerExternalSize =
        externalHeightNominal < externalWidthNominal
          ? externalHeightNominal
          : externalWidthNominal;
      let biggerExternalSize =
        externalHeightNominal > externalWidthNominal
          ? externalHeightNominal
          : externalWidthNominal;

      this.calculatedValues.hangingDropdownRefs = {
        smallerExternalSize: smallerExternalSize,
        biggerExternalSize: biggerExternalSize,
      };

      if (
        currentPage.indexOf("size") === -1 &&
        (smallerExternalSize > hangingMaxDimSmall ||
          biggerExternalSize > hangingMaxDimLarge)
      ) {
        if (hangingDefinition.component !== "Wire") {
          return {
            success: false,
            message: "Table Stand is not available for this frame size",
          };
        }
      }
    } else {
      hangingCost = 0;

      this.calculatedValues.hangingDropdownRefs = {
        smallerExternalSize: 0,
        biggerExternalSize: 0,
      };
    }

    let otherCost = 0;

    this.definitions.filter(function (item) {
      if (item.type === "other-cost") {
        otherCost += item.price;
      }

      return false;
    });

    let backingChoice = "PVC Corrugated Board"; // this.userFields.backing;
    let backingCost = this.definitions.filter(function (item) {
      if (item.type === "backing" && item.name === backingChoice) {
        return true;
      }

      return false;
    })[0].price;

    backingCost *= Number(glazingBackingArea);
    backingCost = backingCost.toFixed(2);

    let frameMaterialSellingCost = framePrice * frameMaterialRequired;
    frameMaterialSellingCost = Math.round(frameMaterialSellingCost * 100) / 100;

    let glazingChoice = this.userFields.glazing;
    let glazingMaterialSellingCost = this.definitions.filter(function (item) {
      if (item.type === "glazing" && item.name === glazingChoice) {
        return true;
      }

      return false;
    })[0].price;

    glazingMaterialSellingCost =
      glazingMaterialSellingCost * glazingBackingArea;
    glazingMaterialSellingCost = glazingMaterialSellingCost.toFixed(2);
    //glazingMaterialSellingCost = Math.round(glazingMaterialSellingCost * 1000) / 1000

    let frameBiggerArea =
      frameHeightNominal < frameWidthNominal
        ? frameWidthNominal
        : frameHeightNominal;

    let laborCosts = this.definitions.filter(function (item) {
      if (item.type === "labor-cost") {
        return true;
      }

      return false;
    });

    laborCosts.sort(function (a, b) {
      return a.price - b.price;
    });

    let laborCost = this.definitions.filter(function (item) {
      if (
        glazingBackingArea * 10000 <= item.area &&
        frameBiggerArea <= item.maxDim
      ) {
        return true;
      }

      return false;
    })[0];

    if (laborCost === undefined) {
      return {
        success: false,
        message: "Please enter the height and width of the artwork",
      };
    }

    laborCost = laborCost.price;

    let totalCost =
      Number(matteCost) +
      Number(frameMaterialSellingCost) +
      Number(glazingMaterialSellingCost) +
      Number(otherCost) +
      Number(backingCost) +
      Number(hangingCost) +
      Number(laborCost);

    totalCost = Math.ceil(totalCost);

    // console.log("+++++++++++++++++++TOTAL", Number(hangingCost));

    if (this.userFields.quantity > 1) {
      totalCost *= this.userFields.quantity;
    }

    totalCost = totalCost.toFixed(2);
    totalCost = parseInt(totalCost);

    let frameSuggestions = this.definitions.filter(function (item) {
      if (item.type === "matte-suggestion" && item.from !== 0) {
        return true;
      }

      return false;
    });

    frameSuggestions.sort(function (a, b) {
      return a.from - b.from;
    });

    let matteSuggestion = 0;
    let minMatteFrameSize = frameSuggestions[0].from;

    if (artworkWidthNominal + artworkHeightNominal >= minMatteFrameSize) {
      matteSuggestion = this.definitions.filter(function (item) {
        if (
          item.type === "matte-suggestion" &&
          artworkWidthNominal + artworkHeightNominal <= item.to &&
          artworkWidthNominal + artworkHeightNominal >= item.from
        ) {
          return true;
        }

        return false;
      })[0];

      if (matteSuggestion === undefined) {
        matteSuggestion = 8.9;
      } else {
        matteSuggestion = matteSuggestion.suggestedWidth;
      }
    } else {
      matteSuggestion = 2;
    }

    let calculatedValues = {
      artworkHeightNominal: artworkHeightNominal,
      artworkWidthNominal: artworkWidthNominal,
      windowHeightNominal: windowHeightNominal,
      windowWidthNominal: windowWidthNominal,
      frameHeightNominal: frameHeightNominal,
      frameWidthNominal: frameWidthNominal,
      externalHeightNominal: externalHeightNominal,
      externalWidthNominal: externalWidthNominal,

      matteBoardHeight: matteBoardHeight,
      matteBoardWidth: matteBoardWidth,

      internalHeight: internalHeight,
      internalWidth: internalWidth,

      rabbetEdgeHeight: rabbetEdgeHeight,
      rabbetEdgeWidth: rabbetEdgeWidth,

      frameWidth: frameWidth,
      frameMaterialRequired: frameMaterialRequired,
      piecesOfFrameMaterialRequired: piecesOfFrameMaterialRequired,
      glazingBackingArea: glazingBackingArea,
      matteCost: matteCost,
      otherCost: otherCost,
      backingCost: backingCost,
      frameMaterialSellingCost: frameMaterialSellingCost,
      glazingMaterialSellingCost: glazingMaterialSellingCost,
      hangingType: hangingType,
      hangingCost: hangingCost,
      laborCost: laborCost,
      totalCost: totalCost,
      matteSuggestion: matteSuggestion,
      maxFrameNominalDimensionSmallerDim: maxFrameNominalDimensionSmallerDim,
      maxFrameNominalDimensionLargerDim: maxFrameNominalDimensionLargerDim,
      maxArtworkNominalDimensionLargerDim: maxArtworkNominalDimensionLargerDim,
      maxArtworkNominalDimensionSmallerDim:
        maxArtworkNominalDimensionSmallerDim,
      hangingDropdownRefs: this.calculatedValues.hangingDropdownRefs,
    };

    this.calculatedValues = calculatedValues;
    return { success: true };
  };
}

export default PriceCalculator;



// WEBPACK FOOTER //
// ./src/components/PriceCalculator.js